import apiConfig from '@apiConfig';
import http from '@core/http';
import { useData } from '@hooks/useData';

export interface SuggestedSearch {
    text: string;
    id: number;
}

export interface CommonDataResponse {
    suggestedSearches: SuggestedSearch[];
}

const DEFAULT_COMMON_DATA: CommonDataResponse = {
    suggestedSearches: [],
};

const fetchCommonData = async (): Promise<CommonDataResponse> => {
    try {
        const response = await http.get(apiConfig.get('common data'));
        return response;
    } catch {
        return DEFAULT_COMMON_DATA;
    }
};

const useCommonData = () => {
    return useData(DEFAULT_COMMON_DATA, fetchCommonData);
};

export default useCommonData;